import { render, staticRenderFns } from "./FileLink.vue?vue&type=template&id=697b5438&scoped=true&"
import script from "./FileLink.vue?vue&type=script&lang=js&"
export * from "./FileLink.vue?vue&type=script&lang=js&"
import style0 from "./FileLink.vue?vue&type=style&index=0&id=697b5438&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697b5438",
  null
  
)

export default component.exports